/*global google*/


import React, { useContext, useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Button, Form, InputGroup, Col, Row, Container, Modal, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChevronDown, 
  faChevronUp, 
  faCartShopping, 
  faArrowLeft,  
  faCalendar,   
  faUtensils,
  faLocationDot,
  faClock,
  faPencil,
  faTruck,
  faBagShopping
} from '@fortawesome/free-solid-svg-icons';
import { getItemAttributeNameById } from '../functions';
import EditCartModal from '../elements/EditCartModal';
import { checkCouponThunk, clearCoupon } from '../store/coupons';
import { useDispatch, useSelector } from 'react-redux';
import EditFreeItemModal from '../elements/EditFreeItemModal';
import { getFreeItemsThunk } from '../store/freeitems';
import { placeOrderThunkPayInStore } from '../store/order';
import { useNavigate } from 'react-router-dom';
import CheckoutApp from '../elements/StripeCheckoutApp';
import loadingJson from '../asset/JSON/loading.json'
import Lottie from 'react-lottie-player';
import  Context  from '../Context';
import {  isStoreOpen, showTimeError } from '../Context/helper';
import Swal from 'sweetalert2';
import { buyPointsThunk, getRewardsThunk } from '../store/rewards';
import { RewardModal } from '../elements/RewardModal';
import EditRewardItemModal from '../elements/EditRewardItemModal';
import { getHoursThunk, getOnlineStatusThunk, getRestaurantThunk, getRestaurantPlanThunk } from '../store/restaurant';
import { clearCheckoutSession, fetchFeesThunk } from '../store/stripe';
import {
  validateCartItemsByCategoryTime,
  parseScheduledOrderMoment,
  findUnavailableCartItems,
} from '../lib/filterCategories';
import { RESTAURANT_SETTINGS } from '../config/restaurantSettings';
import { isRestaurantOpen, isDeliveryAvailable } from '../lib/restaurantHours';

import AddressModal from '../elements/MapboxAutofill';
import './checkout.css';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/** Returns an error message if name/phone are missing or invalid; otherwise null. */
function getContactValidationError(name, phone) {
  const trimmedName = String(name || '').trim();
  const digits = String(phone || '').replace(/\D/g, '');
  if (!trimmedName && digits.length !== 10) {
    return 'Please enter your name and phone number.';
  }
  if (!trimmedName) {
    return 'Please enter your name.';
  }
  if (digits.length !== 10) {
    return 'Please enter a valid 10-digit phone number.';
  }
  return null;
}

const CheckoutPage = ({ fee }) => {
  const navigate = useNavigate();
  const { language, restaurantId, changedCart, setChangedCart} = useContext(Context);
  const [promoCode, setPromoCode] = useState('');
  const [cart, setCart] = useState([]);
  const [freeItem, setFreeItem] = useState(null);
  const [rewardItem, setRewardItem] = useState(null);
  const [orderMethod, setOrderMethod] = useState('pickup'); // pickup or delivery
  const [cartOpen, setCartOpen] = useState(true); // State to toggle cart items
  const [editCartModal, setEditCartModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentUserAddress, setCurrentUserAddress] = useState(null);
  const [addressVerified, setAddressVerified] = useState(false);
  const [addressErrors, setAddressErrors] = useState('');
  const [needDelivery, setNeedDelivery] = useState(false);
  const [checkingCoupon, setCheckingCoupon] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [tip, setTip] = useState(10);
  const [customTip, setCustomTip] = useState(0);
  const [showTipModal, setShowTipModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false); // State for payment modal
  const dispatch = useDispatch();
  const checkCoupon = useSelector(state => state.coupons.coupon);
  const [editFreeItem, setEditFreeItem] = useState(false);
  const freeItems = useSelector((state) => state.freeItems.freeitems);
  const [paymentOption, setPaymentOption] = useState('online');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(false);
  const [payinStoreLoading, setPayinStoreLoading] = useState(false);  // State for loading spinner
  const [paymentSubmitLoading, setPaymentSubmitLoading] = useState(false);  // State for loading spinner
  const [needSchdule, setNeedSchdule] = useState(false)
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [timeModal, setTimeModal] = useState(false)
  const [rewardPoints, setRewardPoints] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isRewardModalOpen, setIsRewardModalOpen] = useState(false);
  const [editRewardItem, setEditRewardItem] = useState(false);
  const hours = useSelector((state) => state.restaurants?.hours);
  const restaurant = useSelector((state) => state.restaurants?.restaurant);
  const plan = useSelector((state) => state.restaurants?.plan);
  const onlineStatus = useSelector((state) => state.restaurants?.onlineStatus);
  const calculatedFees = useSelector((state) => state.stripe?.feeBreakdown);
  const [feeLoading, setFeeLoading] = useState(true);

  const maxDeliveryMiles = RESTAURANT_SETTINGS.maxDeliveryMiles;
  const [showFees, setShowFees] = useState(false);
  const [actualTip, setActualTip] = useState(0);

  const scheduledMoment = useMemo(
    () => (selectedTime ? parseScheduledOrderMoment(selectedTime, hours) : null),
    [selectedTime, hours]
  );

  const unavailableCartItems = useMemo(
    () => findUnavailableCartItems(cart, restaurant?.Categories, hours, scheduledMoment),
    [cart, restaurant?.Categories, hours, scheduledMoment]
  );

  const cartHasUnavailableItems = unavailableCartItems.length > 0;

  useEffect(() => {
    if (cartHasUnavailableItems && showPaymentModal) {
      setShowPaymentModal(false);
    }
  }, [cartHasUnavailableItems, showPaymentModal]);
const [showOrderTypeModal, setShowOrderTypeModal] = useState(true);

const [showAddressModal, setShowAddressModal] = useState(false);
const [savedAddresses, setSavedAddresses] = useState([]);
const [distanceText, setDistanceText] = useState('');
const [addressInput, setAddressInput] = useState('');
  const [aptNumber, setAptNumber] = useState('');
  const [deliveryInstructions, setDeliveryInstructions] = useState('');
  const [discountReward, setDiscountReward] = useState(null);


useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setShowOrderTypeModal(true); // always show on mount
}, []);

  useEffect(() => {
    const generateTimeSlots = () => {
      const slots = [];
      const currentDate = new Date();
      currentDate.setSeconds(0, 0); // Reset seconds and milliseconds
      
      let startTime = new Date();
      let endTime = new Date();
      
      // Set the start time to 11:00 AM and end time to 8:30 PM
      startTime.setHours(11, 0, 0, 0);  // 11:00 AM
      endTime.setHours(20, 30, 0, 0);  // 8:30 PM
      
      // Rounding the start time to the next 5-minute mark
      const minutes = startTime.getMinutes();
      const roundedMinutes = Math.ceil(minutes / 5) * 5;
      startTime.setMinutes(roundedMinutes);
      
      // Generating 5-minute interval slots from the start time to the end time
      while (startTime <= endTime) {
        if (startTime > currentDate) { // Check if the start time is after the current time
          const formattedDate = startTime.toLocaleString('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          });
          slots.push(formattedDate);
        }
        startTime.setMinutes(startTime.getMinutes() + 5); // Increase by 5 minutes
      }
    
      setTimeSlots(slots);
    };
  
    generateTimeSlots();
  }, []);


  const handleTimeSelect = (time) => {
    setSelectedTime(time);
  };


  const contactError = useMemo(
    () => getContactValidationError(name, phone),
    [name, phone]
  );
  const hasValidContact = !contactError;
  const trimmedName = String(name || '').trim();
  const phoneDigits = String(phone || '').replace(/\D/g, '');
  const nameMissing = !trimmedName;
  const phoneMissing = phoneDigits.length !== 10;
  const customerInfoRef = useRef(null);

  // Never wipe name/phone when closing payment — that caused empty Stripe drafts.
  useEffect(() => {
    if (!showPaymentModal) {
      setActiveTab(false);
    }
  }, [showPaymentModal]);

  // If contact becomes invalid while payment is open, close and clear the Stripe draft.
  useEffect(() => {
    if (showPaymentModal && contactError) {
      dispatch(clearCheckoutSession());
      setShowPaymentModal(false);
      setError(contactError);
    }
  }, [showPaymentModal, contactError, dispatch]);



  useEffect(() => { 
    if (restaurantId) {
      dispatch(getFreeItemsThunk(restaurantId));
      dispatch(getHoursThunk(restaurantId));
      dispatch(getRestaurantThunk(restaurantId));
      dispatch(getRestaurantPlanThunk(restaurantId));
    }
  },[restaurantId, dispatch]);

  useEffect(() => {
    setCart(JSON.parse(localStorage.getItem('cart')) || []);
    setFreeItem(JSON.parse(localStorage.getItem('freeItem')) || null);
    setRewardItem(JSON.parse(localStorage.getItem('rewardItem')) || null);
    const storedDiscount = localStorage.getItem(`discountReward-${restaurantId}`);
    setDiscountReward(storedDiscount ? JSON.parse(storedDiscount) : null);
  }, [changedCart, restaurantId]);

  const [clockTick, setClockTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setClockTick((t) => t + 1), 60000);
    return () => clearInterval(interval);
  }, []);

  const isDeliveryAvailableNow = useMemo(
    () => isDeliveryAvailable(hours),
    [hours, clockTick]
  );

  const totalFees = useMemo(() => {
    const sum =
      (+calculatedFees?.tax || 0) +
      (+calculatedFees?.processingFee || 0) +
      (+calculatedFees?.commissionFee || 0) +
      (+calculatedFees?.serviceFee || 0);
    return sum.toFixed(2);
  }, [calculatedFees?.tax, calculatedFees?.processingFee, calculatedFees?.commissionFee, calculatedFees?.serviceFee]);

  const hasExtraFees = useMemo(() => (
    (+calculatedFees?.processingFee > 0) ||
    (+calculatedFees?.commissionFee > 0) ||
    ((orderMethod === 'delivery' && needDelivery) && (+calculatedFees?.serviceFee > 0))
  ), [calculatedFees, orderMethod, needDelivery]);

  const sortedTipOptions = useMemo(() => {
    if (fee?.tip_options?.length > 0) {
      return [...fee.tip_options].sort((a, b) => a - b);
    }
    return [10, 15, 18];
  }, [fee?.tip_options]);

  const showPickupOption = true;
  const showDeliveryOption = true;

  useEffect(() => {
    if (orderMethod === 'delivery' && !isDeliveryAvailableNow) {
      setOrderMethod('pickup');
      setNeedDelivery(false);
      setCurrentUserAddress(null);
      setAddressVerified(false);
      setShowAddressModal(false);
    }
  }, [orderMethod, isDeliveryAvailableNow]);

  const handleSelectPickup = () => {
    setOrderMethod('pickup');
    setNeedDelivery(false);
    setCurrentUserAddress(null);
    setAddressVerified(false);
    setShowAddressModal(false);
  };

  const handleSelectDelivery = () => {
    if (!isDeliveryAvailableNow) {
      Swal.fire({
        icon: 'info',
        title: 'Delivery unavailable',
        text: `Delivery orders close ${RESTAURANT_SETTINGS.deliveryCloseBufferMinutes} minutes before we close. Pickup is still available.`,
        confirmButtonText: 'OK',
      });
      return;
    }
    setOrderMethod('delivery');
    setNeedDelivery(true);
    setShowAddressModal(true);
  };

  const paymentMode = useMemo(() => {
    if (!plan) return 'instore';

    if (plan.instore_online === 'instore') return 'instore';
    if (plan.instore_online === 'online') return 'online';

    const isOnlineAllowed =
      plan.stripe_onboarded &&
      (plan.plan_type === 'pro' ||
        (plan.plan_type === 'free' && plan.online_payment_enabled) ||
        (plan.plan_type === 'custom' && plan.online_payment_enabled));

    if (!isOnlineAllowed) return 'instore';

    let hasCash = false;
    let hasOnline = false;

    if (orderMethod === 'delivery' && needDelivery) {
      hasCash = RESTAURANT_SETTINGS.deliveryPayment.cash;
      hasOnline = RESTAURANT_SETTINGS.deliveryPayment.online;
    } else {
      hasCash = RESTAURANT_SETTINGS.pickupPayment.cash;
      hasOnline = RESTAURANT_SETTINGS.pickupPayment.online;
    }

    if (hasCash && hasOnline) return 'both';
    if (hasOnline) return 'online';
    if (hasCash) return 'instore';
    return 'instore';
  }, [plan, orderMethod, needDelivery]);

  const showInStorePayment = paymentMode === 'both' || paymentMode === 'instore';
  const showOnlinePayment = paymentMode === 'both' || paymentMode === 'online';

  useEffect(() => {
    setCustomTip(actualTip);
  }, [actualTip]);

  useEffect(() => {
    if (!fee || !orderMethod || !plan) return;

    if (plan.instore_online === 'instore') {
      setPaymentOption('in-store');
      return;
    }
    if (plan.instore_online === 'online') {
      setPaymentOption('online');
      return;
    }

    let hasCash = false;
    let hasOnline = false;

    if (orderMethod === 'delivery' && needDelivery) {
      hasCash = RESTAURANT_SETTINGS.deliveryPayment.cash;
      hasOnline = RESTAURANT_SETTINGS.deliveryPayment.online;
    } else {
      hasCash = RESTAURANT_SETTINGS.pickupPayment.cash;
      hasOnline = RESTAURANT_SETTINGS.pickupPayment.online;
    }

    if (hasCash && !hasOnline) setPaymentOption('in-store');
    else if (!hasCash && hasOnline) setPaymentOption('online');
    else if (hasCash && hasOnline) setPaymentOption('online');
    else setPaymentOption('online');
  }, [orderMethod, plan, needDelivery]);

  

  //handle coupon
  const checkCurrentCoupon = async (e) => {
    e.preventDefault();
    setCheckingCoupon(true);
    setCouponError('');
    try { 
       await dispatch(checkCouponThunk(promoCode));
    } catch (error) {
      setCheckingCoupon(false);
    } finally {
      setCheckingCoupon(false);
    }
  };

  const handleRemoveCoupon = () => {
    setPromoCode('');
    setCouponError('');
    dispatch(clearCoupon(''));
  };

  const handleEditCartModal = (item) => {
    setSelectedItem(item);
    setEditCartModal(true);
  };

  const calculateSubtotal = () => {
    let subtotal = cart.reduce(
      (total, cartItem) => total + cartItem.Item.price * cartItem.quantity,
      0
    );  

    cart.forEach((cartItem) => {
      cartItem.options.forEach((option) => {
        subtotal += option.priceModifier * cartItem.quantity;
      });
    });

    return subtotal.toFixed(2);


  };

  const couponId = useMemo(() => {
    if (!checkCoupon) return null;
    if (parseFloat(calculateSubtotal()) < parseFloat(checkCoupon.min_require || 0)) return null;
    return checkCoupon.coupon_id;
  }, [checkCoupon, cart, changedCart]);

  useEffect(() => {
    let timer;
    setFeeLoading(true);

    timer = setTimeout(() => {
      dispatch(
        fetchFeesThunk(
          tip,
          actualTip,
          restaurantId,
          cart,
          currentUserAddress,
          needDelivery,
          couponId,
          phone,
          freeItem?.Item ? freeItem : null,
          null,
          null,
          rewardItem?.Item ? rewardItem : null,
          discountReward,
          null,
          distanceText || null
        )
      ).finally(() => setFeeLoading(false));
    }, 300);

    return () => clearTimeout(timer);
  }, [
    dispatch,
    tip,
    actualTip,
    restaurantId,
    cart,
    currentUserAddress,
    needDelivery,
    couponId,
    phone,
    freeItem,
    rewardItem,
    discountReward,
    changedCart,
    distanceText,
  ]);

  const calculateTaxes = () => {
    return (calculateSubtotal() * fee?.tax).toFixed(2);
  };

  const calculateDiscount = () => {
    const subtotal = parseFloat(calculateSubtotal());
    let discount = 0;

    if (checkCoupon && subtotal >= parseFloat(checkCoupon.min_require)) {
      if (checkCoupon.discount_type === 'Percentage') {
        discount = (subtotal * (parseFloat(checkCoupon.discount) / 100)).toFixed(2);
      } else {
        discount = parseFloat(checkCoupon.discount);
      }
    }

    return discount;
  };

  const calculateServiceFee = () => {
    const subtotal = parseFloat(calculateSubtotal());
    return (subtotal * fee?.service_fee + parseFloat(fee?.commission_fee))?.toFixed(2);
  };

  const calculateTip = () => {
    const subtotal = parseFloat(calculateSubtotal());
    return ((subtotal * tip) / 100).toFixed(2);
  };

  const calculateTotal = () => {
    const subtotal = parseFloat(calculateSubtotal());
    const taxes = parseFloat(calculateTaxes());
    const discount = calculateDiscount();
    const commissionFee = parseFloat(fee?.commission_fee);
    const serviceFee = orderMethod === 'delivery' ? parseFloat(calculateServiceFee()) : 0;
    const deliveryFee = orderMethod === 'delivery' ? parseFloat(fee?.delivery_fee) : 0;
    const tipAmount = parseFloat(customTip || calculateTip());

    let total = (subtotal + taxes - discount + serviceFee + deliveryFee + tipAmount).toFixed(2);
    if (orderMethod === 'pickup') {
      total = (parseFloat(total) + commissionFee).toFixed(2);
    }
    return total;
  };

  useEffect(() => { 
    if(checkCoupon?.min_require && parseFloat(calculateSubtotal()) < parseFloat(checkCoupon.min_require)){
      setCouponError('Minimum order amount of $' + checkCoupon.min_require + ' is required to use this coupon.');
    }
  },[checkCoupon, calculateSubtotal()])

  const handleTipSelect = (percentage) => {
    setTip(percentage);
    setCustomTip(0);
    setActualTip(0);
 };

 const handleCustomTip = () => {
  setTip(0);
   setShowTipModal(true);
 };

 const incrementTip = () => setCustomTip(prevTip => +prevTip + 1);
 const decrementTip = () => setCustomTip(prevTip => +Math.max(0, prevTip - 1));


 const handleCustomTipChange = (e) => {
   if (/^\d*$/.test(e.target.value)) {
     const val = Number(e.target.value);
     setCustomTip(val);
     setActualTip(val);
   }
   setTip(0);
 };


  const handleEditFreeItem = (item) => {
    setSelectedItem(item);
    setEditFreeItem(true);
  };

  const handleEditRewardItem = (item) => {
    setSelectedItem(item);
    setEditRewardItem(true);
  };

    function toTitleCase(str) {
    return str
      ?.split(" ")
      ?.map(word => {
        // Capitalize first letter only if it's alphabetic
        if (/^[a-z]/i?.test(word)) {
          return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
        }
        return word;
      })
      ?.join(" ");
  }

  const restaurantAddress = `${toTitleCase('1880 Braselton Hwy, Suite 122,')}, ${toTitleCase('Lawrenceville GA 30043, USA')}`;

let scriptLoaded = false;

function loadGoogleMapsScript() {
  return new Promise((resolve, reject) => {
    if (scriptLoaded && window.google) {
      resolve(window.google);
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBVBmPNmWThlFAv8lyHtESSsZIQLHiDl30&libraries=places";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      scriptLoaded = true;
      resolve(window.google);
    };

    script.onerror = (e) => reject(e);

    document.head.appendChild(script);
  });
}
// Usage in your component
useEffect(() => {
  if (!showAddressModal && orderMethod !== 'delivery') return;

  loadGoogleMapsScript()
    .then(() => {
      handleScriptLoad();
    })
    .catch((error) => {
      console.error("Google Maps API failed to load", error);
    });
}, [showAddressModal, orderMethod]);
  
  let autocomplete;
  const handleScriptLoad = (retries = 0) => {
    const input = document.getElementById('autocomplete');
    if (!input) {
      if (retries < 20) setTimeout(() => handleScriptLoad(retries + 1), 100);
      return;
    }
    if (!window.google?.maps?.places) return;
    autocomplete = new google.maps.places.Autocomplete(input, { types: ['geocode'] });
    autocomplete.addListener('place_changed', handlePlaceSelect);
  };

  async function handlePlaceSelect() {
    const place = autocomplete.getPlace();

    if (!place.geometry) {
      setAddressErrors('Please enter a valid address');
      setAddressInput('');
      return;
    }

    const isWithinDistance = await checkDistance(place.formatted_address);

    setCurrentUserAddress(place.formatted_address);
    setAddressInput(place.formatted_address);
    setAddressVerified(isWithinDistance);
    setAddressErrors(
      isWithinDistance ? '' : `Sorry, we can only deliver up to ${maxDeliveryMiles} miles.`
    );
  }

const checkDistance = async (userAddress) => {
  const service = new google.maps.DistanceMatrixService();
  return new Promise((resolve) => {
    service.getDistanceMatrix(
      {
        origins: [userAddress],
        destinations: [restaurantAddress],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      },
      (response, status) => {
        if (status === 'OK') {
          const element = response.rows[0].elements[0];

          if (element.status === 'OK') {
            const distanceInMiles = element.distance.value * 0.000621371;

            setDistanceText(Number(distanceInMiles).toFixed(2));

            if (distanceInMiles <= maxDeliveryMiles) {
              setAddressErrors('');
              setAddressVerified(true);
              resolve(true);
            } else {
              setAddressErrors(
                `Sorry, we cannot deliver to places more than ${maxDeliveryMiles} miles away.`
              );
              setAddressVerified(false);
              resolve(false);
            }
          } else {
            setAddressErrors('Unable to calculate driving distance. Please try again later.');
            setAddressVerified(false);
            setDistanceText(null);
            resolve(false);
          }
        } else {
          setAddressErrors('Error retrieving distance matrix. Please try again later.');
          setAddressVerified(false);
          setDistanceText(null);
          resolve(false);
        }
      }
    );
  });
};


  
  
  const needAmountReached = () => {
    // Iterate through freeItems array
    const freeItemed = JSON.parse(localStorage.getItem('freeItem'));

    if(freeItemed?.Item){
    for (const freeItem of freeItems) {
      // Find the matching ReedemableItem based on item 
      for(const item of freeItem.ReedemableItems){ 
        if(item?.Item?.id === freeItemed?.Item?.id){
          return +freeItem.need_amount <= +calculateSubtotal();
        }
      }
    }} else { 
      return true;
    }
  };

  const showRestaurantTimeError = () => {
    const timeZone = hours?.time_zone || "EST";
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  
    const formattedHours = days.map(day => {
      const key = day.toLowerCase();
      const raw = hours?.[key];
  
      if (!raw || raw.toLowerCase() === "closed") return `${day}: Closed`;
  
      const [main, breakStr] = raw.split("|");
      const display = `${main}${breakStr ? ` (Break: ${breakStr})` : ""}`;
      return `${day}: ${display}`;
    }).join("\n");
  
    Swal.fire({
      icon: 'error',
      title: 'Please come back later.',
      html: `<pre style="text-align:left">${formattedHours}</pre><br/><b>Time Zone:</b> ${timeZone}`
    });
  };
  const handlePlaceOrder = useCallback(async () => {
    const earlyContactError = getContactValidationError(name, phone);
    if (earlyContactError) {
      setError(earlyContactError);
      customerInfoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const normalizedName = String(name || '').trim();
    const normalizedPhone = String(phone || '').replace(/\D/g, '');
    if (normalizedName !== name) setName(normalizedName);
    if (normalizedPhone !== phone) setPhone(normalizedPhone);

    try {
      const status = await dispatch(getOnlineStatusThunk(restaurantId));
      if (status?.stop_order) {
        Swal.fire({
          icon: 'info',
          title: 'Online Ordering Unavailable',
          text: 'The restaurant is not accepting online orders right now. Please come back later.',
          confirmButtonText: 'Got it',
        });
        return;
      }
    } catch {
      if (onlineStatus?.stop_order) {
        Swal.fire({
          icon: 'info',
          title: 'Online Ordering Unavailable',
          text: 'The restaurant is not accepting online orders right now. Please come back later.',
          confirmButtonText: 'Got it',
        });
        return;
      }
    }

    let latestHours;
    try {
      latestHours = await dispatch(getHoursThunk(restaurantId));
    } catch (hoursErr) {
      console.warn('Restaurant hours refresh failed:', hoursErr);
    }

    if (!latestHours) {
      Swal.fire({
        icon: 'error',
        title: 'Unable to verify restaurant hours',
        text: 'Please try again before proceeding to payment.',
        confirmButtonText: 'Got it',
      });
      return;
    }

    const restaurantOpen = isRestaurantOpen(latestHours);
    if (!restaurantOpen) {
      showRestaurantTimeError();
      return;
    }

    if (orderMethod === 'delivery' && needDelivery && !isDeliveryAvailable(latestHours)) {
      Swal.fire({
        icon: 'info',
        title: 'Delivery unavailable',
        text: `Delivery orders close ${RESTAURANT_SETTINGS.deliveryCloseBufferMinutes} minutes before we close. Please choose pickup or try again earlier.`,
        confirmButtonText: 'OK',
      });
      return;
    }

    if (cartHasUnavailableItems) {
      validateCartItemsByCategoryTime(
        cart,
        restaurant?.Categories,
        latestHours,
        scheduledMoment,
      );
      return;
    }

    const isValid = validateCartItemsByCategoryTime(
      cart,
      restaurant?.Categories,
      latestHours,
      scheduledMoment,
    );
    if (!isValid) return;

    // Re-check after awaits so a cleared/edited field cannot slip through.
    const lateContactError = getContactValidationError(normalizedName, normalizedPhone);
    if (lateContactError) {
      setError(lateContactError);
      customerInfoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    try {
      const blockRes = await fetch(
        `https://hutaoadmin.onrender.com/api/customer/blocked-phone/${restaurantId}/${normalizedPhone}`
      );
      if (blockRes.ok) {
        const blockData = await blockRes.json();
        if (blockData?.blocked) {
          Swal.fire({
            icon: 'error',
            title: 'Order not allowed',
            html: 'You have been blocked from placing order.<br />If you think this is a mistake please contact the restaurant directly.',
            confirmButtonText: 'OK',
          });
          return;
        }
      }
    } catch (blockErr) {
      console.warn('Blocked phone check failed:', blockErr);
    }

    setError('');
    setShowPaymentModal(true);
  }, [
    dispatch,
    restaurantId,
    onlineStatus,
    cartHasUnavailableItems,
    cart,
    restaurant?.Categories,
    scheduledMoment,
    name,
    phone,
    orderMethod,
    needDelivery,
  ]);

  const handlePaymentMethodChange = useCallback((selectedOption) => {
    setPaymentOption(selectedOption);
    if (selectedOption !== 'online') {
      dispatch(clearCheckoutSession());
    }
  }, [dispatch]);

  const handleModalClose = useCallback(() => {
    dispatch(clearCheckoutSession());
    setShowPaymentModal(false);
  }, [dispatch]);



  const handlePayInStore = async () => {
    const payContactError = getContactValidationError(name, phone);
    if (payContactError) {
      setError(payContactError);
      setShowPaymentModal(false);
      return;
    }

    const normalizedName = String(name || '').trim();
    const normalizedPhone = String(phone || '').replace(/\D/g, '');

    if (paymentMode === 'online' || !showInStorePayment) {
      Swal.fire({
        icon: 'info',
        title: 'Online payment only',
        text: 'This order must be paid online. Please pay with a card.',
      });
      return;
    }

    if (orderMethod === 'delivery' && needDelivery && !RESTAURANT_SETTINGS.deliveryPayment.cash) {
      Swal.fire({
        icon: 'info',
        title: 'Online payment only',
        text: 'Delivery orders must be paid online.',
      });
      return;
    }

    if (cartHasUnavailableItems) {
      validateCartItemsByCategoryTime(
        cart,
        restaurant?.Categories,
        hours,
        scheduledMoment,
      );
      return;
    }

    setPayinStoreLoading(true);
    try {
      await dispatch(
        placeOrderThunkPayInStore(
          restaurantId,
          'in-store',
          normalizedName,
          normalizedPhone,
          tip,
          customTip,
          needDelivery ? currentUserAddress : 'Pickup',
          cart,
          couponId,
          freeItem?.Item ? freeItem : null,
          null,
          selectedTime || 'ASAP',
          rewardItem?.Item ? rewardItem : null,
          null,
          aptNumber || null,
          deliveryInstructions || null,
          null,
          distanceText,
          null,
          discountReward || null
        )
      );

      await dispatch(
        buyPointsThunk(restaurantId, normalizedPhone, normalizedName, calculatedFees?.subtotal || calculateSubtotal())
      );

      setChangedCart(!changedCart);
      navigate('/orderconfirmed');
    } catch (error) {
      console.error('An error occurred:', error);
      Swal.fire({
        icon: 'error',
        title: 'Could not place order',
        text: error?.message || 'Please try again.',
      });
    } finally {
      setPayinStoreLoading(false);
    }
  }
  
  const handleSchduleTimeClick = () => { 
    setNeedSchdule(true)

    setTimeModal(true)
  }

// Function to handle raw phone value and store it
const handlePhoneChange = (e) => {
  const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
  if (input.length <= 10) {
    setPhone(input); // Store only raw 10-digit phone number
  }

  // Automatically trigger reward points check if input is exactly 10 digits
  if (input.length === 10) {
    checkRewardPoints(input);
  }
};

// Function to format phone number for display
const formatPhoneNumber = (phone) => {
  if (phone.length > 6) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  } else if (phone.length > 3) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
  } else if (phone.length > 0) {
    return `(${phone}`;
  }
  return '';
};

const checkRewardPoints = async (phoneNumber) => {
  setLoading(true);
  try {
    const points = await dispatch(getRewardsThunk(restaurantId, phoneNumber));
    if(points){
      setRewardPoints(points);
    }else {
      setRewardPoints(0);
    }
  } catch (error) {
    console.error('Error fetching reward points:', error);
  } finally {
    setLoading(false);
  }
};
const handleSelectSavedAddress = async (addr) => {
  setAddressInput(addr);
  setCurrentUserAddress(addr);
  const ok = await checkDistance(addr);
  if (ok) {
    setAddressVerified(true);
    setAddressErrors('');
  } else {
    setAddressVerified(false);
    setAddressErrors(`Sorry, we can only deliver up to ${maxDeliveryMiles} miles.`);
  }
};

const handleSaveAddress = (apt, instructions) => {
  setAptNumber(apt || '');
  setDeliveryInstructions(instructions || '');
  setOrderMethod('delivery');
  setNeedDelivery(true);

  const key = `savedAddresses_${restaurantId}`;
  // Get existing saved addresses from localStorage or start with empty array
  const saved = localStorage.getItem(key);
  const savedAddresses = saved ? JSON.parse(saved) : [];

  // Add new address only if it doesn't already exist
  if (!savedAddresses.includes(addressInput)) {
    savedAddresses.unshift(addressInput);
    // Keep only the 5 most recent addresses
    localStorage.setItem(key, JSON.stringify(savedAddresses.slice(0, 5)));
  }

  // Close the modal after saving
  setShowOrderTypeModal(false);
};

  return (
    <>
    {/* <Header /> */}
<Modal show={showOrderTypeModal} onHide={() => setShowOrderTypeModal(false)} centered size="lg" backdrop="static"
keyboard={false}>
  <Modal.Header >
    <Modal.Title className="fw-bold">How would you like to receive your order?</Modal.Title>
  </Modal.Header>

 <Modal.Body>
  {/* Toggle Buttons */}
  <div className="d-flex justify-content-center mb-4">
      <div className="btn-group d-flex rounded-3 overflow-hidden border border-danger" role="group" style={{ width: '100%' }}>
  {showPickupOption && (
  <button
    type="button"
    className={`btn ${orderMethod === 'pickup' ? 'btn-danger text-white' : 'btn-outline-danger'} fw-semibold d-flex align-items-center justify-content-center py-2 px-3`}
    style={{ flex: 1, fontSize: '1rem', borderRadius: 0 }}
    onClick={handleSelectPickup}
  >
    <i className="bi bi-shop me-2"></i> Pickup
  </button>
  )}

  {showDeliveryOption && (
  <button
    type="button"
    className={`btn ${orderMethod === 'delivery' ? 'btn-danger text-white' : 'btn-outline-danger'} fw-semibold d-flex align-items-center justify-content-center py-2 px-3 ${!isDeliveryAvailableNow ? 'opacity-50' : ''}`}
    style={{ flex: 1, fontSize: '1rem', borderRadius: 0 }}
    onClick={handleSelectDelivery}
    aria-disabled={!isDeliveryAvailableNow}
  >
    <i className="bi bi-truck me-2"></i> Delivery
  </button>
  )}
    </div>
  </div>

  {!isDeliveryAvailableNow && (
    <p className="text-muted small text-center mb-3">
      Delivery closes {RESTAURANT_SETTINGS.deliveryCloseBufferMinutes} minutes before store close. Pickup is still available.
    </p>
  )}

  {/* Conditional Content */}
  {orderMethod === 'pickup' && (
    <div className="text-center text-muted small p-3 bg-light rounded">
      <div><strong>Ready in 10–15 minutes</strong></div>
      <div>Pick up from the restaurant counter</div>
    </div>
  )}

  {orderMethod === 'delivery' && (
    <div>
      <AddressModal
        showAddressModal={showAddressModal}
        setShowAddressModal={setShowAddressModal}
        onSaveAddress={handleSaveAddress}
        addressInput={addressInput}
        setAddressInput={setAddressInput}
        addressVerified={addressVerified}
        addressErrors={addressErrors}
        distanceText={distanceText}
        restaurantId={restaurantId}
        handleSelectSavedAddress={handleSelectSavedAddress}
      />
    </div>
  )}
</Modal.Body>


{orderMethod !== 'delivery' && (
  <Modal.Footer>
    <Button  size="lg"
        className="fw-bold rounded-pill w-100" onClick={() => setShowOrderTypeModal(false)}>
      Save
    </Button>
  </Modal.Footer>
)}
</Modal>


    <Container className="checkout-page" style={{marginTop:'135px'}}> 
      <Row>
  <Col md={7}>
    {/* Back Navigation */}
    <div 
      className="d-flex align-items-center mb-4 cursor-pointer text-danger" 
      onClick={() => navigate('/order')}
    >
      <i className="fas fa-arrow-left me-2 fs-5"></i>
      <h5 className="mb-0 fw-semibold">Continue Shopping</h5>
    </div>

    {/* Checkout Section */}
<div className="section text-center px-2">
  {/* Header */}

  {/* Order Method Summary */}
    <div className="bg-white rounded-4 p-4 shadow-sm mb-3 checkout-summary-card">
    <p className="text-muted small mb-2 text-center">How would you like to receive your order?</p>
    <div className="d-flex justify-content-center mb-3">
      <div className="btn-group d-flex rounded-3 overflow-hidden border border-danger w-100" role="group">
        <button
          type="button"
          className={`btn ${orderMethod === 'pickup' ? 'btn-danger text-white' : 'btn-outline-danger'} fw-semibold py-2`}
          style={{ flex: 1, borderRadius: 0 }}
          onClick={handleSelectPickup}
        >
          <FontAwesomeIcon icon={faBagShopping} className="me-2" />
          Pickup
        </button>
        <button
          type="button"
          className={`btn ${orderMethod === 'delivery' ? 'btn-danger text-white' : 'btn-outline-danger'} fw-semibold py-2 ${!isDeliveryAvailableNow ? 'opacity-50' : ''}`}
          style={{ flex: 1, borderRadius: 0 }}
          onClick={handleSelectDelivery}
          aria-disabled={!isDeliveryAvailableNow}
        >
          <FontAwesomeIcon icon={faTruck} className="me-2" />
          Delivery
        </button>
      </div>
    </div>
    {!isDeliveryAvailableNow && (
      <p className="text-muted small text-center mb-3">
        Delivery closes {RESTAURANT_SETTINGS.deliveryCloseBufferMinutes} minutes before store close.
      </p>
    )}
    <div className="d-flex justify-content-between align-items-start mb-2">
      <div>
    <div className="mb-2">
      <FontAwesomeIcon
        icon={orderMethod === 'pickup' ? faBagShopping : faTruck}
        className="me-2 text-danger fs-5"
      />
      <span className="fw-semibold text-dark fs-5">
        {orderMethod === 'pickup' ? 'You selected Pickup' : 'You selected Delivery'}
      </span>
    </div>
      </div>
      <button
        type="button"
        className="btn btn-sm btn-outline-danger"
        onClick={() => setShowOrderTypeModal(true)}
      >
        Change
      </button>
    </div>

    {/* Conditional Content */}
    {orderMethod === 'pickup' ? (
      <>
        <p className="text-muted mb-1">
          Pick up your order from the restaurant counter.
        </p>
        <span className="badge bg-daanger-subtle text-danger rounded-pill px-3 py-1">
          Ready in 10–15 minutes
        </span>
      </>
    ) : (
      <>
        <p className="text-muted mb-1">
          We’ll deliver to:
        </p>
        <div className="text-dark fw-semibold mb-2">
          <FontAwesomeIcon icon={faLocationDot} className="me-1 text-danger" />
          {currentUserAddress || <span className="text-danger">No address entered</span>}
        </div>
        {(aptNumber || deliveryInstructions) && (
          <p className="text-muted small mb-2">
            {[aptNumber, deliveryInstructions].filter(Boolean).join(' · ')}
          </p>
        )}
        <span className="badge bg-danger-subtle text-danger rounded-pill px-3 py-1">
          {selectedTime ? (
            <>
              <FontAwesomeIcon icon={faClock} className="me-1" />
              Scheduled: {selectedTime}
            </>
          ) : (
            'Arriving in 20–30 minutes'
          )}
        </span>
      </>
    )}
  </div>

  {/* Edit Button */}
  <div>
    <Button
      variant="outline-danger"
      size="sm"
      className="rounded-pill px-4 fw-semibold"
      onClick={() => setShowOrderTypeModal(true)}
    >
      Change Method
    </Button>
  </div>
</div>




    {/* Location Info */}
    {/* <div className="text-center text-muted small">
      <i className="fas fa-map-marker-alt me-2"></i>
      1880 Braselton Hwy #122, Lawrenceville, GA 30043
    </div> */}
  </Col>
        <Col md={5}>
          <div className="section cart-summary cart-summary-panel">
          <div
  className="d-flex justify-content-between align-items-center"
  style={{
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '0.5rem',
    marginBottom: '1rem',
    cursor: 'pointer',
    userSelect: 'none',
    flexWrap: 'nowrap'
  }}
  onClick={() => setCartOpen(!cartOpen)}
>
  <h5
    className="fw-semibold mb-0 d-flex align-items-center gap-2"
    style={{
      fontSize: '1rem', // base size
      margin: 0,
    }}
  >
    <span className="text-truncate" style={{ maxWidth: '100%' }}>
      Cart summary ({cart.length} item{cart.length !== 1 ? 's' : ''})
    </span>
    <FontAwesomeIcon icon={cartOpen ? faChevronUp : faChevronDown} />
  </h5>
  <span className="fw-bold text-dark">
    {feeLoading ? <Skeleton width={60} height={20} duration={0.5} /> : `$${calculatedFees?.subtotal || calculateSubtotal()}`}
  </span>

  {cart.length > 0 && (
    <button
      onClick={(e) => {
        e.stopPropagation();
        localStorage.removeItem('cart');
        localStorage.removeItem('freeItem');
        setChangedCart(!changedCart);
      }}
      className="btn btn-outline-danger"
      style={{
        borderRadius: '25px',
        padding: '0.25rem 0.75rem',
        fontSize: '0.75rem',
        fontWeight: 600,
        minWidth: '80px',
        whiteSpace: 'nowrap',
      }}
    >
      Clear Cart
    </button>
  )}
</div>


            {cartOpen && (
              <>
              
      


              <div>

                {rewardItem?.Item && (
                    <div
                      onClick={() => handleEditRewardItem({
                        id: rewardItem?.Item.id,
                        name: rewardItem?.Item?.name,
                        price: rewardItem?.Item.price,
                        quantity: rewardItem?.quantity,
                        special_instructions: rewardItem?.special_instructions,
                        image_url: rewardItem?.Item?.image_url,
                        Restaurant_Item_Attributes: rewardItem?.Item?.Restaurant_Item_Attributes,
                        options: rewardItem?.options,
                      })}
                      className="cart-item d-flex align-items-start mb-3"
                    >
                          <img
                      src={rewardItem.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'}
                      alt={rewardItem.Item.name}
                      className="cart-item-image me-3"
                    />
                    <div className="cart-item-details flex-grow-1">
                    <p className='item-name mb-1'>{language === 'en' ? rewardItem?.Item?.name : rewardItem?.Item?.chinese_name}</p>
                            {rewardItem?.options?.map((attribute) => (
                              <p className="item-attribute small m-0" key={attribute.id}>
                                {getItemAttributeNameById(attribute.id, rewardItem.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                              </p>
                            ))}
                            {rewardItem?.special_instructions && (
                              <p className="item-instructions small m-0">
                                <strong>**</strong> {rewardItem?.special_instructions}
                              </p>
                            )}
                          </div>
                          <div className="cart-item-quantity d-flex align-items-center justify-content-center">
                            <span className="item-quantity">1</span>
                            </div>
                            <p className="item-price ms-3">Reward</p>

                    </div>

                  )
                      }

              {freeItem?.Item && (
                    <div
                      onClick={() => handleEditFreeItem({
                        id: freeItem?.Item.id,
                        name: freeItem?.Item?.name,
                        price: freeItem?.Item.price,
                        quantity: freeItem?.quantity,
                        special_instructions: freeItem?.special_instructions,
                        image_url: freeItem?.Item?.image_url,
                        Restaurant_Item_Attributes: freeItem?.Item?.Restaurant_Item_Attributes,
                        options: freeItem?.options,
                      })}
                      className="cart-item d-flex align-items-start mb-3"
                    >
                          <img 
                      src={freeItem.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'} 
                      alt={freeItem.Item.name} 
                      className="cart-item-image me-3" 
                    />
                    <div className="cart-item-details flex-grow-1">
                    <p className='item-name mb-1'>{language === 'en' ? freeItem?.Item?.name : freeItem?.Item?.chinese_name}</p>
                            {freeItem?.options?.map((attribute) => (
                              <p className="item-attribute small m-0" key={attribute.id}>
                                {getItemAttributeNameById(attribute.id, freeItem.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                              </p>
                            ))}
                            {freeItem?.special_instructions && (
                              <p className="item-instructions small m-0">
                                <strong>**</strong> {freeItem?.special_instructions}
                              </p>
                            )}
                          </div>
                          <div className="cart-item-quantity d-flex align-items-center justify-content-center">
                            <span className="item-quantity">1</span>
                            </div>
                            <p className="item-price ms-3">Free</p>
                            

                    </div>
                    
                  )  
                  }
              </div>

              <div>
                {cart.map((item, index) => (
                  <div key={index} className="cart-item d-flex align-items-start mb-3"
                    onClick={() => handleEditCartModal({
                      id: item?.Item.id,
                      name: item?.Item?.name,
                      price: item?.Item.price,
                      special_instructions: item?.special_instructions,
                      image_url: item?.Item?.image_url,
                      Restaurant_Item_Attributes: item?.Item?.Restaurant_Item_Attributes,
                      options: item?.options,
                      index: index,
                    })}
                  >
                    <img 
                      src={item.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'} 
                      alt={item.Item.name} 
                      className="cart-item-image me-3" 
                    />
                    <div className="cart-item-details flex-grow-1">
                      <p className="item-name mb-1">{language === 'en' ? item?.Item?.name : item?.Item?.chinese_name}</p>
                      {item?.options?.map((attribute, idx) => (
                        <p className="item-attribute small m-0" key={idx}>
                          {getItemAttributeNameById(attribute.id, item.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                        </p>
                      ))}
                      {item?.special_instructions && (
                        <p className="item-instructions small m-0">
                          <strong>**</strong> {item?.special_instructions}
                        </p>
                      )}
                    </div>
                    <div className="cart-item-quantity d-flex align-items-center justify-content-center">
                      <span className="item-quantity">{item.quantity}</span>
                    </div>
                    <p className="item-price ms-3">${item.price}</p>
                  </div>
                ))}
              </div>
              </>
            )}
          </div>
          <div className="section promotion">
            <h5>Promotion</h5>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Add promo code"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
              />
              <Button variant="outline-primary" onClick={(e) => checkCurrentCoupon(e)}>
                {checkingCoupon ? <span className="spinner-border spinner-border-sm"></span> : 'Apply'}
              </Button>
            </InputGroup>
            {checkCoupon && parseFloat(calculateSubtotal()) >= parseFloat(checkCoupon.min_require) && (
              <div className="mt-2">
                <p className="text-success">Coupon applied! Discount: ${calculateDiscount()}</p>
                <Button variant="link" onClick={handleRemoveCoupon}>Remove coupon</Button>
              </div>
            )}
            {checkCoupon && parseFloat(calculateSubtotal()) < parseFloat(checkCoupon.min_require) && (
              <div className="mt-2">
                <p className="text-danger">Minimum order amount of ${checkCoupon.min_require} is required to use this coupon.</p>
              </div>
            )}
            {checkCoupon && checkCoupon.message && (
              <div className="mt-2">
                <p className="text-danger">{checkCoupon.message}</p>
              </div>
            )}
            {!checkCoupon && (
              <div className="mt-2">
                <p className="text-danger">{couponError || 'Invalid coupon code.'}</p>
              </div>
            )}
          </div>

          <div className="section customer-detail" ref={customerInfoRef}>
  <h5 style={{ fontSize: '1.2rem', marginBottom: '0.35rem' }}>Customer Info</h5>
  <p className="customer-info-hint text-muted mb-3">
    Name and phone are required so we can confirm your order and send updates.
  </p>

  <div className="row">
  {/* Name Input */}
  <div className="col-12 col-md-6 mb-3">
    <label htmlFor="name" className="form-label customer-field-label">
      Full name <span className="text-danger">*</span>
    </label>
    <input
      type="text"
      className={`form-control${nameMissing && error ? ' is-invalid' : ''}`}
      id="name"
      value={name}
      onChange={(e) => {
        setName(e.target.value);
        if (error) setError('');
      }}
      onBlur={() => setName((prev) => String(prev || '').trim())}
      placeholder="e.g. Jane Smith"
      required
      autoComplete="name"
      maxLength={40}
      aria-required="true"
      aria-invalid={nameMissing && !!error}
    />
    {nameMissing ? (
      <p className={`customer-field-help mb-0 ${error ? 'text-danger' : 'text-muted'}`}>
        Please enter your name.
      </p>
    ) : null}
  </div>

  {/* Phone Number Input with Display Formatting */}
  <div className="col-12 col-md-6 mb-3">
    <label htmlFor="phone" className="form-label customer-field-label">
      Phone number <span className="text-danger">*</span>
    </label>
    <input
      type="tel"
      className={`form-control${phoneMissing && error ? ' is-invalid' : ''}`}
      id="phone"
      value={formatPhoneNumber(phone)} // Display formatted value
      onChange={(e) => {
        handlePhoneChange(e);
        if (error) setError('');
      }}
      placeholder="(123) 456-7890"
      required
      autoComplete="tel"
      inputMode="numeric"
      maxLength={14} // To account for display formatting
      aria-required="true"
      aria-invalid={phoneMissing && !!error}
    />
    {phoneMissing ? (
      <p className={`customer-field-help mb-0 ${error ? 'text-danger' : 'text-muted'}`}>
        {phoneDigits.length === 0
          ? 'Please enter a 10-digit phone number.'
          : `Enter ${10 - phoneDigits.length} more digit${10 - phoneDigits.length === 1 ? '' : 's'}.`}
      </p>
    ) : (
      <p className="customer-field-help text-muted mb-0">Used for order updates.</p>
    )}
  </div>


</div>
</div>

<div className="section tip-options">
<div className='row'>
  <div className="col-12">
      {/* Loading Spinner */}
  {loading && (
    <div className="col-12 mb-3 text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )}

      <RewardModal
        isOpen={isRewardModalOpen}
        onClose={() => setIsRewardModalOpen(false)}
        points={rewardPoints}
        phone={phone}
        handlePhoneChange={handlePhoneChange}
      />
    </div>

</div>
<div className='row'>
  <div className="col-12">
  {!loading && (
      <div className="col-12 ">
        {phone.length !== 10 ? (
          <div className="alert alert-warning">
            Please enter a 10 digit phone number above to see your points.
          </div>
        ) : phone.length === 10 && !rewardPoints ? (
          <div className="alert alert-warning">
            You dont have any reward points, Start ordering with this number to earn reward points to this number.
          </div>
        ) : (
          <div className="alert alert-success">
            You have <strong>{rewardPoints}</strong> reward points!
          </div>
        )}
      </div>
    )}
  </div>
  <button
        className="btn btn-primary mt-3 w-100"
        onClick={() => setIsRewardModalOpen(true)}
      >
        See All Available Rewards
      </button>
</div>

</div>




        
          <div className="section order-total order-total-panel">
            <h5 className="order-total-title">Order total</h5>
            <div className="order-summary">
              <p className="order-summary-line">
                <span>Subtotal</span>
                <span>
                  {feeLoading ? <Skeleton width={60} height={20} duration={0.5} /> : `$${calculatedFees?.subtotal || calculateSubtotal()}`}
                </span>
              </p>

              <div
                className={`order-summary-line order-summary-toggle ${hasExtraFees ? '' : 'order-summary-toggle--disabled'}`}
                onClick={hasExtraFees ? () => setShowFees((prev) => !prev) : undefined}
              >
                <span className="order-summary-toggle-label">
                  Taxes{hasExtraFees ? ' & Fees' : ''}
                  {hasExtraFees && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      className={`order-summary-chevron ${showFees ? 'order-summary-chevron--open' : ''}`}
                    />
                  )}
                </span>
                <span>
                  {feeLoading ? <Skeleton width={60} height={20} duration={0.5} /> : `$${totalFees}`}
                </span>
              </div>

              {hasExtraFees && showFees && (
                <div className={`fees-breakdown ${showFees ? 'fees-breakdown--open' : ''}`}>
                  {feeLoading ? (
                    [...Array(3)].map((_, i) => (
                      <p key={i} className="order-summary-line order-summary-line--detail">
                        <Skeleton width={100} height={18} duration={0.5} />
                        <Skeleton width={50} height={18} duration={0.5} />
                      </p>
                    ))
                  ) : (
                    <>
                      {+calculatedFees?.tax > 0 && (
                        <p className="order-summary-line order-summary-line--detail">
                          <span>Taxes</span>
                          <span>${calculatedFees.tax}</span>
                        </p>
                      )}
                      {+calculatedFees?.processingFee > 0 && (
                        <p className="order-summary-line order-summary-line--detail">
                          <span>Processing Fee</span>
                          <span>${calculatedFees.processingFee}</span>
                        </p>
                      )}
                      {+calculatedFees?.commissionFee > 0 && (
                        <p className="order-summary-line order-summary-line--detail">
                          <span>Service Fee</span>
                          <span>${calculatedFees.commissionFee}</span>
                        </p>
                      )}
                      {(orderMethod === 'delivery' && needDelivery) && (+calculatedFees?.serviceFee > 0) && (
                        <p className="order-summary-line order-summary-line--detail">
                          <span>Service Fee</span>
                          <span>${calculatedFees.serviceFee}</span>
                        </p>
                      )}
                    </>
                  )}
                </div>
              )}

              {orderMethod === 'delivery' && (
                <p className="order-summary-line">
                  {feeLoading ? (
                    <>
                      <Skeleton width={110} height={20} duration={0.5} />
                      {addressVerified ? (
                        <Skeleton width={60} height={20} duration={0.5} />
                      ) : (
                        <Skeleton width={150} height={20} duration={0.5} />
                      )}
                    </>
                  ) : (
                    <>
                      <span>Delivery Fee</span>
                      <span>
                        {addressVerified
                          ? `$${calculatedFees?.deliveryFee || fee?.delivery_fee || '0.00'}`
                          : <em className="order-summary-waiting">Waiting for address...</em>}
                      </span>
                    </>
                  )}
                </p>
              )}

              {feeLoading && +calculatedFees?.discount > 0.01 ? (
                <p className="order-summary-line">
                  <Skeleton width={100} height={20} duration={0.5} />
                  <Skeleton width={60} height={20} duration={0.5} />
                </p>
              ) : (
                +calculatedFees?.discount > 0 && (
                  <p className="order-summary-line">
                    <span>Discount</span>
                    <span>-${calculatedFees.discount}</span>
                  </p>
                )
              )}

              <p className="order-summary-line">
                <span>Tip</span>
                <span>
                  {feeLoading ? (
                    <Skeleton width={50} height={20} duration={0.5} />
                  ) : (
                    `$${calculatedFees?.tip || parseFloat(customTip || calculateTip()).toFixed(2)}`
                  )}
                </span>
              </p>

              <div className="tip-pill-group">
                {sortedTipOptions.map((percent) => (
                  <span
                    key={percent}
                    className={`tip-pill ${tip === +percent ? 'active' : ''}`}
                    onClick={() => handleTipSelect(percent)}
                  >
                    {percent}%
                  </span>
                ))}
                <span
                  className={`tip-pill ${tip === 0 ? 'active' : ''}`}
                  onClick={handleCustomTip}
                >
                  Custom
                </span>
              </div>

              {+calculatedFees?.total > 0 && !feeLoading && (
                <div className="savings-banner">
                  You&apos;re saving{' '}
                  <strong>
                    {(
                      (+calculatedFees.subtotal || 0) * 0.11 +
                      Math.max(+calculatedFees.totalBfDiscount - +calculatedFees.total, 0)
                    ).toFixed(2)}
                  </strong>{' '}
                  by ordering directly from us vs. other websites
                </div>
              )}

              <p className="order-summary-total">
                <span>Total</span>
                <span>
                  {feeLoading ? (
                    <Skeleton width={80} height={30} duration={0.5} />
                  ) : (
                    <span className="order-summary-total-values">
                      {+calculatedFees?.totalBfDiscount > +calculatedFees?.total && (
                        <span className="order-summary-total-strike">
                          ${Number(calculatedFees.totalBfDiscount).toFixed(2)}
                        </span>
                      )}
                      <span>${Number(calculatedFees?.total || calculateTotal()).toFixed(2)}</span>
                    </span>
                  )}
                </span>
              </p>
            </div>
          </div>
          {calculateSubtotal() > 0 && (
            <p class="text-primary fw-bold text-center mt-2">
    You Will Earn {(calculateSubtotal() * 10).toFixed(2)} reward points this order
</p>
          )
          }
            <p className="text-danger">{!needAmountReached() && 'You need to reach the minimum amount to redeem the free item.'}</p>
            {orderMethod === 'delivery' && !isDeliveryAvailableNow && (
              <div className="checkout-alert checkout-alert--error">
                Delivery is closed for today. Orders must be placed at least {RESTAURANT_SETTINGS.deliveryCloseBufferMinutes} minutes before we close.
              </div>
            )}
            {orderMethod === 'delivery' && (calculatedFees?.subtotal || calculateSubtotal()) < (+fee?.min_delivery_amount || 20) && (
              <div className="checkout-alert checkout-alert--error">
                Minimum order amount of ${fee?.min_delivery_amount || 20} in subtotal is required for delivery.
              </div>
            )}
            {orderMethod === 'delivery' && !addressVerified && (
              <div className="checkout-alert checkout-alert--error">
                Please enter a valid address within {maxDeliveryMiles} miles of the restaurant.
              </div>
            )}
            {cartHasUnavailableItems && (
              <p className="text-danger">
                Some items in your cart are not available right now. Please remove them to continue:{' '}
                {unavailableCartItems
                  .map(({ item }) => item?.Item?.name || item?.name || 'Item')
                  .join(', ')}
              </p>
            )}
            {isStoreOpen() === false && <p className="text-danger">Sorry, we are currently closed. Refer to our store hours.</p>}
            {error && <p className="text-danger">{error}</p>}
            <p className="text-muted text-center">
  {(() => {
    const now = new Date();
    const day = now.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
    const date = now.toLocaleDateString("en-US", { month: "numeric", day: "numeric" });
    const time = now.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
    const info = hours?.[day];
    if (!info || info.toLowerCase() === "closed") return `Today ${date}, ${time} — Closed`;
    const [main, br] = info.split("|");
    const [o, c] = main.split("-");
    return `${date}: Open ${o}–${c}${br ? ` | Break ${br}` : ""}`;
  })()}
</p>

          {(() => {
            const isSubmitDisabled =
              feeLoading
              || (orderMethod === 'delivery' && !isDeliveryAvailableNow)
              || (orderMethod === 'delivery' && !addressVerified)
              || !needAmountReached()
              || (orderMethod === 'delivery' && (+calculatedFees?.subtotal || calculateSubtotal()) < (+fee?.min_delivery_amount || 20))
              || cartHasUnavailableItems;

            return (
              <>
                {!hasValidContact && (
                  <div className="checkout-alert checkout-alert--error" role="status">
                    {nameMissing && phoneMissing
                      ? 'Enter your name and phone number above to continue.'
                      : nameMissing
                        ? 'Enter your name above to continue.'
                        : 'Enter a valid 10-digit phone number above to continue.'}
                  </div>
                )}
                <button
                  type="button"
                  className={`checkout-proceed-btn ${isSubmitDisabled ? 'checkout-proceed-btn--disabled' : ''}`}
                  disabled={isSubmitDisabled}
                  onClick={handlePlaceOrder}
                >
                  {feeLoading ? (
                    <span className="checkout-proceed-loading">
                      <span className="checkout-proceed-spinner" aria-hidden="true" />
                      Loading...
                    </span>
                  ) : (
                    'Proceed to Payment ➔'
                  )}
                </button>
              </>
            );
          })()}
        </Col>
      </Row>
      <EditCartModal modal={editCartModal} item={selectedItem} setModal={setEditCartModal} />
      <EditFreeItemModal  modal={editFreeItem} item={selectedItem} setModal={setEditFreeItem} />
      <EditRewardItemModal  modal={editRewardItem} item={selectedItem} setModal={setEditRewardItem} />
      <Modal show={showTipModal} onHide={() => setShowTipModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Enter Custom Tip</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="d-flex align-items-center justify-content-center">
          <button className="btn btn-outline-primary" onClick={decrementTip}>
            <FontAwesomeIcon icon={faChevronDown} />
          </button>
          <Form.Control
            type="tel"
            min="0"
            value={customTip}
            onChange={handleCustomTipChange}
            placeholder="Enter custom tip amount"
            className="mx-2 text-center"
            style={{ maxWidth: '100px' }}
          />
          <button className="btn btn-outline-primary" onClick={incrementTip}>
            <FontAwesomeIcon icon={faChevronUp} />
          </button>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <button className="w-100 btn btn-primary" onClick={() => setShowTipModal(false)}>Save</button>
      </Modal.Footer>
    </Modal>
      <Modal show={showPaymentModal} onHide={handleModalClose} backdropClassName="overlay" centered size="lg">

        
        <>
          <Modal.Header closeButton>
            <Modal.Title>Payment Method</Modal.Title>
          </Modal.Header>
          <Modal.Body>
  {paymentSubmitLoading ? (
    <Lottie 
      loop
      animationData={loadingJson}
      play
    />
  ) : (
    <>
      <div className="d-flex flex-column gap-2">
        {showInStorePayment && (
          <button
            type="button"
            className={`payment-button w-100 ${paymentOption === 'in-store' ? 'primary' : 'outline-primary'}`}
            onClick={() => handlePaymentMethodChange('in-store')}
          >
            Pay In Store
          </button>
        )}
        {showOnlinePayment && (
          <button
            type="button"
            className={`payment-button w-100 ${paymentOption === 'online' ? 'primary' : 'outline-primary'}`}
            onClick={() => handlePaymentMethodChange('online')}
          >
            Pay Online
          </button>
        )}
      </div>
      {paymentOption === 'in-store' && showInStorePayment && (
        <button
          type="button"
          className="black-button p-3 mt-3 w-100"
          onClick={handlePayInStore}
          disabled={payinStoreLoading}
        >
          {payinStoreLoading ? (
            <span className="spinner-border spinner-border-sm" />
          ) : (
            'Place Order (In-Store)'
          )}
        </button>
      )}
      {paymentOption === 'online' && showOnlinePayment && !cartHasUnavailableItems && hasValidContact && (
                   <>
                   <CheckoutApp
                   key={`${restaurantId}-${paymentOption}-${trimmedName}-${phoneDigits}`}
                   tip={tip}
                   customTip={actualTip || null}
                   restaurantId={restaurantId}
                   name={trimmedName}
                   phone={phoneDigits}
                   cartItems={cart}
                   coupon={couponId}
                   address={needDelivery ? currentUserAddress : 'Pickup'}
                   selectedTime={selectedTime || 'ASAP'}
                   freeItem={freeItem?.Item ? freeItem : null}
                   rewardItem={rewardItem?.Item ? rewardItem : null}
                   discountReward={discountReward || null}
                   email={null}
                   account_id={plan?.account_id}
                   aptNumber={aptNumber || null}
                   deliveryInstructions={deliveryInstructions || null}
                   distanceText={distanceText || null}
                   specialItem={null}
                   />   
                 {/* </> */}
                  {/* <button  className="black-button  p-3 mt-3" onClick={handlePayInStore} disabled={payinStoreLoading}>
                    {payinStoreLoading ? (
                      <span className="spinner-border spinner-border-sm"></span>
                    ) : (
                      'Place Order'
                    )}
                  </button> */}
                  </>
              )}

      {/* <div>
        {error && <p className="text-danger">{error}</p>}
        <div className="row mb-2">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-3">
            <input
              type="text"
              className="form-control"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
              style={{ textAlign: 'center' }}
              required
              disabled={activeTab}
              maxLength={20}
            />
          </div>
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-3">
            <input
              type="tel"
              className="form-control"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Phone (10 digits, no dashes or spaces)"
              style={{ textAlign: 'center' }}
              required
              disabled={activeTab}
              maxLength={10}
            />
          </div>
          {!activeTab ? (
            <Button variant='primary' className="text-center w-100 mt-4 black-button" onClick={handleContinueCheckout}>
              Continue
            </Button>
          ) : null}
          {activeTab && (
            <>
            <div className='d-flex justify-content-center align-items-center ' onClick={goBack}
                            style={{ fontSize: '20px', cursor: 'pointer', gap: '10px', color: 'black' }}

            >
              <FontAwesomeIcon
                icon={faArrowLeft}
              />
              <p className="text-center mt-3">Back</p>
              </div>
   
            </>
          )}
        </div>
      </div> */}
    </>
  )}
</Modal.Body>

        </>
      </Modal>

 

      <Modal show={timeModal} onHide={() => setTimeModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Schedule Time</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group>
        <Form.Label>Select a {needSchdule ? 'delivery' : 'pickup'} time</Form.Label>
        <div 
          className="d-flex flex-column" 
          style={{
            maxHeight: '500px',
            overflowY: 'scroll',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '6px',
            backgroundColor: '#f9f9f9',
          }}
        >
          {timeSlots.length > 0 ? (
            timeSlots.map((slot, index) => (
              <span
                key={index}
                className={`time-slot mb-2 p-2 ${selectedTime === slot ? 'selected-time-slot' : ''}`}
                onClick={() => handleTimeSelect(slot)}
                style={{
                  cursor: 'pointer',
                  border: '1px solid grey',
                  borderRadius: '4px',
                  fontSize: '1.1rem',
                  color: selectedTime === slot ? '#fff' : 'red',
                  backgroundColor: selectedTime === slot ? 'red' : '#fff',
                  transition: 'background-color 0.3s ease, color 0.3s ease',
                }}
              >
                {slot}
              </span>
            ))
          ) : (
            <div>No available time slots</div>
          )}
        </div>
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <button 
    className='w-100 btn-primary'
      onClick={() => setTimeModal(false)}
    >
      Confirm
    </button>
  </Modal.Footer>
</Modal>

    </Container>
    </>
  );
};

export default CheckoutPage;
